<template>
    <div class="opportunity">
        <div class="opportunity__header">
            <img
                class="flag opportunity__flag"
                :src="resource.country.flag"
                v-if="resource.country"
                v-tippy="resource.country.name"
            />
            <h2 class="opportunity__title">{{ resource.projectName }}</h2>
            <span v-if="resource.urgent" class="pill pill--urgent opportunity__pill">Urgent</span>
        </div>
        <DataList
            class="opportunity__datalist"
            :columns="2"
            :items="[
                {
                    title: 'Posted',
                    value: resource.createdAt,
                    icon: 'calendar',
                    isSector: false,
                },
                {
                    title: 'Opportunity Type',
                    value: (resource.mandated) ? 'Mandated' : 'Non-Mandated',
                    icon: 'lock',
                    isSector: false,
                },
                {
                    title: 'Deal Type',
                    value: resource.dealType,
                    icon: 'deal',
                    isSector: false,
                },
                {
                    title: 'Projected transaction value',
                    value: `${resource.projectedValueFrom}m-${resource.projectedValueTo}m`,
                    icon: 'value',
                    isSector: false,
                },
            ]"
        />
        <div class="datalist opportunity__sectors">
            <div class="datalist__item dataitem">
                <dt v-text="'Sector'" class="dataitem__title" />
                <dd class="dataitem__value">
                    <span
                        v-for="sector in resource.sectors"
                        v-text="sector.name"
                        class="sector"
                    />
                </dd>
            </div>
        </div>
        <router-link
            v-if="resource && resource.id"
            :to="{
                name: 'view-opportunity',
                params : {
                    opportunity_id: resource.id
                }
            }"
            class="btn btn--outline"
        >
            View Opportunity
        </router-link>
    </div>
</template>
<script>
import DataList from '@components/DataList/List.vue';
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'SectorPostCardOpportunity',
    components: {
        SvgIcon,
        DataList
    },
    props: {
        resource: {
            type: Object,
            required: true,
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.opportunity {
    border: .1rem solid $border;
    border-radius: .4rem;
    padding: 2rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1.5rem;

    .opportunity__header {
        display: flex;
        align-items: center;
        column-gap: 1rem;
        width: 100%;

        .opportunity__flag {
            flex: 0 0 2.4rem;
            width: 2.4rem;
            position: relative;
            top: -.1rem;
        }

        .opportunity__title {
            margin-bottom: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            flex: 1 1 auto;
        }

        .opportunity__pill {

        }
    }

    .opportunity__datalist {

    }

    .btn {
        align-self: flex-start;
    }
}
</style>
